import "react-app-polyfill/ie9"
import "core-js/fn/array/find"
import React from "react"
import ReactDOM from "react-dom"
import registerServiceWorker from "./registerServiceWorker"
import App from "./App.jsx"
import { AppContainer } from "react-hot-loader"
import { BrowserRouter } from "react-router-dom"
import ScrollToTop from "components/ScrollToTop"
import ApolloClient from "apollo-boost"
import defaults from "./state"
import { ApolloProvider } from "react-apollo"

const target = document.getElementById("root")

const client = new ApolloClient({
  clientState: {
    defaults,
  },
})

const render = Component => {
  ReactDOM.render(
    <ApolloProvider client={client}>
      <BrowserRouter>
        <ScrollToTop>
          <AppContainer>
            <Component />
          </AppContainer>
        </ScrollToTop>
      </BrowserRouter>
    </ApolloProvider>,
    target
  )
}

render(App)
registerServiceWorker()

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept("./App.jsx", () => {
    render(App)
  })
}



// WEBPACK FOOTER //
// ./src/index.js